import {AdCampaignEnum, AdStrategyStatusEnum,} from "@/views/modules/ad/common/enum";

export default  [
  { id: 'status',
    header: '有效',
    field: 'slot:status',
    minWidth: '60px',
    fixed: 'left',
    default: true,
    disabled: true
  },
  {
    id: 'campaignName',
    header: '广告活动',
    field: 'slot:campaignName',
    minWidth: '220px',
    sortable: true,
    fixed: 'left',
    default: true,
    disabled: true,
    helpObj:{ 
      help: '广告活动的名称。部分广告数据需要48小时才能更新完整，所以在某些时间范围内数据会有所延迟', 
      source: '亚马逊广告API-Campaign Name', 
      instructions: '您可以制定广告活动命名规范来区分各个广告活动，以便用名称来识别 广告活动'
    }
  },
  { id: 'servingStatus',
  header: '状态',
  field: 'slot:servingStatus',
  minWidth: '120px',
  default: true
  },
  {
    id: 'strategyStatus',
     header: '分时策略', 
     field: 'slot:strategyStatus', 
     minWidth: '120px', 
     default: true, 
     options: AdStrategyStatusEnum.option,
    helpObj: {
      help:'添加分时策略的情况',
      source: '广告-分时策略中添加或广告管理中具体的广告下添加分时策略' 
    }
  },
  { id: 'ruleStatus', header: '自动规则', field: 'slot:ruleStatus', minWidth: '120px', default: true},
  { id: 'targetingType', 
  header: '投放类型', 
  field: 'option(badge):targetingType', 
  minWidth: '100px',
   default: true, 
   options: AdCampaignEnum.SP.targetingTypeOption
  },
  {
    id: 'bidStrategy', 
    header: '竞价策略', 
    field: 'slot:bidStrategy', 
    minWidth: '160px', 
    default: true, 
    options: AdCampaignEnum.SP.bidStrategyOption, 
    helpObj: {
      help: "您可根据广告活动目标选择您希望为广告竞价的方式。 您可以随时从广告活动设置页面更改您的竞价策略", 
      source: '亚马逊广告API-Bidding Strategy'
    }
  },
  {
    id: 'startDate',
     header: '开始日期', 
     field: 'startDate',
     minWidth: '110px', 
     sortable: true, 
     default: true, 
    helpObj: {help: '广告活动生效的开始日期（站点市场时间）', 
    source: '亚马逊广告API-Start date',
  }
  },
  {
    id: 'endDate', 
    header: '结束日期', 
    field: 'slot:endDate',
     minWidth: '125px', 
     sortable: true, 
     default: true,
    helpObj: {help: '广告活动的结束日期（站点市场时间）', 
    source: '亚马逊广告API-End date',
    instructions: '“无结束时间”表示广告会一直生效，可修改“结束日期”进行调整'
  }
  },

  {
    id: 'suggestedBudget', 
    header: 'slot:suggestedBudget:建议预算',
     minWidth: '180px',  
     field: 'slot:suggestedBudget', 
      summary: true, 
      default: true,
  },

  {
    id: 'dailyBudget', header: '每日预算', minWidth: '110px', prefix: 'currencySymbol', field: 'slot:dailyBudget', scale: 2, summary: true, sortable: true, align: 'right', default: true,
    helpObj: {help: '每天该广告的最大广告花费，超过该花费后当天广告暂停，过市场时间24:00以后自动开启。', source: '亚马逊广告API-Budget', instructions: '实际每日花费最多可超出每日预算的25%'}
  },
  {
    id: 'originalBudget', header: '原始预算', minWidth: '110px', prefix: 'currencySymbol', field: 'originalBudget', scale: 2, summary: true , sortable: true, align: 'right', default: true,
    helpObj: {help: '原始预算是备用字段，如果您未使用积加的广告策略功能，原始预算不会对您的广告竞价产生任何影响。 当您的店铺、站点初次授权后，原始预算即为初次更新广告数据时记录的预算。通过您手动修改了预算，会自动同步为最新的原始预算。', source: '系统自动记录', instructions: '备用字段，对使用了分时策略的广告活动，记录分时调整前的原始预算值'},
  },
  {
    id: 'impressions', header: '曝光量', field: 'impressions', summary: true, minWidth: '100px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告被展示的次数',source: '亚马逊广告API-Impressions', instructions: '亚马逊会对近几天的数据进行检查，被识别出来的无效点击，系统会予以删除'},
  },
  {
    id: 'clicks', header: '点击量', field: 'clicks', summary: true, minWidth: '95px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告被点击的次数',source: '亚马逊广告API-Clicks', instructions: '亚马逊会对近几天的数据进行检查，被识别出来的无效点击，系统会予以删除'},
  },
  {
    id: 'ctr', header: 'CTR', field: 'ctr', suffix: '%', scale: 2, summary: 'percent:clicks/impressions', minWidth: '100px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告点击率',source: '系统计算', instructions: '亚马逊会对近几天的数据进行检查，被识别出来的无效点击，系统会予以删除', formula: '点击量/曝光量*100%'},
  },
  {
    id: 'cost', header: '花费', field: 'cost', summary: true, prefix: 'currencySymbol', scale: 2, minWidth: '120px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告的花费，单次点击价格总和',source: '亚马逊广告API-Spend', instructions: '被识别出来的无效点击，系统会予以删除。对应的花费也可能有变化'},
  },
  {
    id: 'cpc', header: 'CPC', field: 'cpc', scale: 2, summary: 'ratio:cost/clicks', prefix: 'currencySymbol', minWidth: '90px', sortable: true, align: 'right', default: true,
    helpObj: {help: '单次点击价格，因每次点击费用都不相同，取平均值。',source: '系统计算', formula: '花费/点击量'},
  },
  {
    id: 'orders', header: '广告总订单量', field: 'adsOrders', summary: true, minWidth: '130px', sortable: true, align: 'right', default: true,
    helpObj: {help: '因广告被点击带来的订单量总数，不包括发货后退货订单（仅订单为发货状态后才会计入有效订单，亚马逊发货周期为2-3天，数据会有一定延迟)', source: '亚马逊广告API-Order', instructions: '广告总订单量指指7天内（SP广告）、14天（SD、SB广告）售出的推广商品及店铺中其他商品的订单总和。您的订单量最长可能需要12小时才会更新。因此，“今天”日期范围内的销售数据可能会延迟。未成功支付的款项和 72小时内取消的订单的将从订单量中删除'},
  },
  {
    id: 'cvr', header: 'CVR', field: 'cvr', suffix: '%', summary: 'percent:adsOrders/clicks', scale: 2, minWidth: '110px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告转化率',source: '系统计算', formula: '广告总订单量/点击量*100%'},
  },
  {
    id: 'cpa', header: 'CPA', field: 'cpa', prefix: 'currencySymbol', scale: 2, summary: 'ratio:cost/adsOrders', minWidth: '100px', sortable: true, align: 'right', default: true,
    helpObj: {help: '平均每笔订单的花费',source: '系统计算', formula: '花费/广告总订单量'},
  },
  {
    id: 'sales', header: '广告总销售额', field: 'adsSales', summary: true, prefix: 'currencySymbol', scale: 2, minWidth: '130px', sortable: true, align: 'right', default: true,
    helpObj: {help: '因广告被点击而向买家售出的商品的价值总额',source: '亚马逊广告API-Sales', instructions: '广告总销售额指7天内（SP广告）、14天（SD、SB广告）售出的推广商品及店铺中其他商品的销售额。您的销售数据最长可能需要 12 小时才会更新。因此，“今天”日期范围内的销售数据可能会延迟。未成功支付的款项和 72 小时内取消的订单的金额将从销售总额中删除'},
  },
  {
    id: 'acos', header: 'ACOS', field: 'acos', suffix: '%', summary: 'percent:cost/adsSales', scale: 2, minWidth: '110px', sortable: true, align: 'right', default: true,
    helpObj: {help: '广告投入产出比',source: '系统计算', formula: '花费/广告总销售额*100%'},
  },
  {
    id: 'roas', header: 'ROAS', field: 'roas', suffix: '%', summary: 'percent:adsSales/cost', scale: 2, minWidth: '100px', sortable: true, align: 'right', default: true,
    helpObj: {help: '投入产出比',source: '系统计算', formula: '广告总销售额/花费*100%'},
  },
  { id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', default: true, notCustomColumn: true},
]